<template>
  <div class="betslip-wrapper">
    <component :is="betslipType"
               :theme="theme"
               :bettingLocked="bettingLocked"
               :bettingDisabled="bettingDisabled"
               :predefinedStakes="predefinedStakes"
               :payinDisabled="payinDisabled">
    </component>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Expanded from './Expanded';
import Compact from './Compact';

export default {
  name: 'Betslip',
  props: {
    betslipType: {
      type: String,
      default: 'Expanded',
    },
    config: {
      type: Object,
      default: () => {},
    },
    payinDisabled: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: Object,
      default: () => {},
    },
    balance: {
      type: Object,
      default: () => {},
    },
    theme: {
      type: String,
      default: 'dark',
    },
    bettingLocked: {
      type: Boolean,
      default: false,
    },
    bettingDisabled: {
      type: Boolean,
      default: false,
    },
    predefinedStakes: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Expanded,
    Compact,
  },
  methods: {
    ...mapActions([
      'setConfig',
      'togglePayinAction',
      'setTicketRules',
      'setBalanceValue',
    ]),
  },
  created() {
    this.setConfig(this.config);
    this.setTicketRules(this.rules);
    this.setBalanceValue(this.balance);
  },
  watch: {
    payinDisabled(value) {
      this.togglePayinAction(value);
    },
    balance(value) {
      this.setBalanceValue(value);
    },
  },
};
</script>
